var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowBatteryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.102,
    height: 24.051,
    viewBox: "0 0 48.102 24.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1154",
    "data-name": "Trac\\xE9 1154",
    d: "M2,11.81A4.81,4.81,0,0,1,6.81,7H38.077a4.81,4.81,0,0,1,4.81,4.81H47.7A2.4,2.4,0,0,1,50.1,14.215v9.62A2.4,2.4,0,0,1,47.7,26.241h-4.81a4.81,4.81,0,0,1-4.81,4.81H6.81A4.81,4.81,0,0,1,2,26.241Zm40.887,9.62V16.62h2.405v4.81Zm-4.81-9.62H6.81V26.241H38.077V11.81ZM10.418,14.215a1.2,1.2,0,0,0-1.2,1.2v7.215a1.2,1.2,0,0,0,1.2,1.2h2.405a1.2,1.2,0,0,0,1.2-1.2V15.418a1.2,1.2,0,0,0-1.2-1.2Z",
    transform: "translate(-2 -7)",
    fill: "#de3939",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBatteryIcon);
export default __webpack_public_path__ + "static/media/LowBatteryIcon.b391de59ab842bcb77929880085e516e.svg";
export { ForwardRef as ReactComponent };